import React, {useEffect, useRef, useState} from 'react';
import {ICommonGallery} from "./interfaces";
import {isMobile, isTablet} from "../../domain/common";
import {IListItem} from "../list-page/interfaces/interfaces";
import GridProduct from "../products/product/grid-product";
import { useWindowResizeObserver } from '../../domain/animations/animations-provider';
import { initEqualHeight } from '../list-page/services/list-page-provider';
import ProductCommonGalleryTitle from "./components/product-common-gallery-title";
import ProductTeaserButton from "./components/product-teaser-button";
import ProductCustomGalleryTitle from "./components/product-custom-gallery-title";
interface ICommonGalleryProps {
    commonGalleryProps: ICommonGallery,
    productGallery:IListItem[]
}
/**
 * the entry point
 */
const CommonProductGallery = (props: ICommonGalleryProps) => {
    const commonGalleryProps = props?.commonGalleryProps;
    const isMobileScreen = isMobile();
    const isTabletScreen = isTablet();

    const pathArr = window.location.pathname?.split("/");
    commonGalleryProps.urlPathName = pathArr[1];

    const isDebug = false; // useAppSelector((store) => store.isDebug);
    const productGallery = props.productGallery;
    commonGalleryProps.totalProducts = productGallery.length

    // used for elements equal height (title, tagline, etc.)
    const [ width ] = useWindowResizeObserver();
    const containerRef = useRef<HTMLDivElement>(null);

    //numberOfRowsShown
    let desctopSize = productGallery.length >= commonGalleryProps?.desctopSize ? commonGalleryProps?.desctopSize : productGallery.length;
    const tabletSize = productGallery.length >= commonGalleryProps?.tabletSize ? commonGalleryProps?.tabletSize : productGallery.length;
    const mobileSize = productGallery.length >= commonGalleryProps?.mobileSize ? commonGalleryProps?.mobileSize : productGallery.length;

    let classEx = "";

    //calc width and classes
    if(commonGalleryProps?.desctopSize > productGallery.length){
        classEx = `lg:w-${desctopSize+1}/6`;
    }
    const numberOfProductsShown = isMobileScreen ?  parseInt(commonGalleryProps.numberOfRowsShown) * mobileSize : isTabletScreen ? parseInt(commonGalleryProps.numberOfRowsShown) * tabletSize : parseInt(commonGalleryProps.numberOfRowsShown) * desctopSize;
    //console.log('CommonProductGallery START: ',commonGalleryProps);
    const [showMoreLess, setShowMoreLess] = useState(commonGalleryProps?.showMoreLess);
    //console.log(`numberOfProductsShown ${commonGalleryProps?.dataType} (${productGallery.length}): `,numberOfProductsShown);

    //console.log(`commonGalleryProps ${commonGalleryProps?.dataType}  `,commonGalleryProps);
    /**
     * titles and taglines should have equal height in grid view
     */
    useEffect(() => {

        (async () => {
            if(width > 0 && productGallery && productGallery.length > 0) {
                await initEqualHeight(containerRef.current, width, 'grid', desctopSize, tabletSize, mobileSize);
            }
        })();
    }, [
        // update on document width change
        width, desctopSize, tabletSize, mobileSize, productGallery
    ]);
    function getLessMoreText(text:string){
        if(!text || text === '')
            return  '';
        if(text === 'less')
            return 'Show Less'
        else{
            return 'Show All ' + productGallery.length + ' plugins'
        }
    }
    return (
                <>
                    {isDebug &&
                        <div className="">
                            <div>isMobileScreen: {isMobileScreen.toString()}</div>
                            <div>useBuiltInTitle: {commonGalleryProps?.useBuiltInTitle}</div>
                            <div>dataCustomTitle: {commonGalleryProps?.dataCustomTitle}</div>
                            <div>dataCustomSubTitle: {commonGalleryProps?.dataCustomSubTitle}</div>
                            <div>dataType: {commonGalleryProps?.dataType}</div>
                            <div>dataTab: {commonGalleryProps?.dataTab}</div>
                            <div>totalProducts: {commonGalleryProps?.totalProducts}</div>
                            <div>isButtonAndNoteHidden: {commonGalleryProps?.isButtonAndNoteHidden}</div>
                            <div>isTaglineHidden: {commonGalleryProps.isTaglineHidden}</div>
                            <div>listName: {commonGalleryProps.listName}</div>
                            <div>dataID: {commonGalleryProps.dataID}</div>
                            <div>numberOfRowsShown: {commonGalleryProps.numberOfRowsShown}</div>
                            <div>numberOfProductsShown: {numberOfProductsShown}</div>
                            <div>isPriceDiscountBadgeHidden: {commonGalleryProps.isPriceDiscountBadgeHidden}</div>
                            <div>isDataExplore: {commonGalleryProps.isDataExplore}</div>
                            <div>isPriceFirstRowHidden: {commonGalleryProps.isPriceFirstRowHidden}</div>
                            <div>isPriceThirdRowHidden: {commonGalleryProps.isPriceThirdRowHidden}</div>
                            <div>useSrcDetails: {commonGalleryProps.useSrcDetails}</div>
                        </div>
                    }
                    {productGallery.length > 0 &&  commonGalleryProps?.useBuiltInTitle && <ProductCommonGalleryTitle commonGalleryProps={commonGalleryProps} />}

                    {productGallery.length > 0 &&  commonGalleryProps?.dataCustomTitle && <ProductCustomGalleryTitle commonGalleryProps={commonGalleryProps} />}


                    <div className="" ref={ containerRef } >
                            <ul className={   commonGalleryProps?.staticClass ?? `common-product-gallery grid ${commonGalleryProps?.gridGap} grid-cols-${mobileSize} md:grid-cols-${tabletSize} xl:grid-cols-${desctopSize} mx-auto ${classEx} prod-mobile-2col `}>
                                {productGallery?.slice(0,
                                    (
                                        showMoreLess === 'less'
                                        || productGallery?.length < numberOfProductsShown
                                    )
                                        ? productGallery?.length
                                        : numberOfProductsShown)
                                    .map((pg, i) => {
                                    return (
                                        <li key={i}
                                            className={`my-4`} >
                                            <GridProduct
                                                product={ pg }
                                                removeImgLink={commonGalleryProps?.isRemoveImgLink}
                                                removeTitleLink={commonGalleryProps?.isRemoveTitleLink}
                                                isTaglineHidden={commonGalleryProps?.isTaglineHidden}
                                                isButtonAndNoteHidden={commonGalleryProps?.isButtonAndNoteHidden}
                                                isPriceFirstRowHidden={commonGalleryProps?.isPriceFirstRowHidden}
                                                isPriceSecondRowHidden={commonGalleryProps?.isPriceSecondRowHidden}
                                                isPriceThirdRowHidden={commonGalleryProps?.isPriceThirdRowHidden}
                                                isFirstMerchRowHidden={commonGalleryProps?.isFirstMerchRowHidden}
                                                isPriceDiscountBadgeHidden={commonGalleryProps?.isPriceDiscountBadgeHidden}
                                                isPriceClockHidden={commonGalleryProps?.isClockHidden}
                                                isExpectedShippingHidden={commonGalleryProps?.isExpectedShippingHidden}
                                                useSrcDetails={commonGalleryProps?.useSrcDetails}
                                                listName={commonGalleryProps.listName}
                                                priceCustomText={commonGalleryProps?.priceCustomText}
                                                classes="h-full"
                                                imageHeight={commonGalleryProps?.imageHeight}
                                            />
                                        </li>
                                    )
                                })}
                            </ul>
                    </div>
                    {
                        // <div>
                        //     <div>dataType: {commonGalleryProps?.dataType}</div>
                        //     <div>numberOfProductsShown: {numberOfProductsShown}</div>
                        //     <div>productGallery.length: {productGallery.length}</div>
                        // </div>
                    }
                    {commonGalleryProps?.dataType === "teaser" && numberOfProductsShown < productGallery.length &&
                        <ProductTeaserButton commonGalleryProps={commonGalleryProps} />
                    }
                    { showMoreLess !== null && showMoreLess !== '' && numberOfProductsShown < productGallery.length &&
                        <div className="flex justify-center relative">
                            {showMoreLess === 'more' && <div className="list-menu-grad-top" />}
                            <button type={'button'} className="w-btn w-64 lg:w-96"
                                    onClick={evt =>
                                        {setShowMoreLess(showMoreLess === 'less' ? 'more' : 'less')}}
                            >{getLessMoreText(showMoreLess)}</button>
                        </div>
                    }
                </>
    )
};

export default CommonProductGallery;